import { ERRORTYPE } from 'utils/validation';
import { RegulatoryErrorData, RegulatoryFormData } from './types';

export const validation = (values: RegulatoryFormData): RegulatoryErrorData => {
  const { hasTraderOnAccount, proxyType } = values;

  return {
    ...(hasTraderOnAccount && !proxyType ? { proxyType: ERRORTYPE.REQUIRED } : {}),
  };
};

export default validation;
